import { computed, ref, watch } from '@vue/composition-api'
import { assign } from 'lodash'
import MessageList from './components/MessageList/MessageList.vue'
import NewMessageForm from './components/NewMessageForm/NewMessageForm.vue'
import useRequest from '@/compositions/useRequest'
import { camel } from '@/utils/ws'
import useMessages from '@/compositions/useMessages'
import { capitalizedWord } from '@/utils/capitalizedWord'

export default {
  components: {
    MessageList,
    NewMessageForm,
  },
  channels: {
    ChatChannel: {
      connected() {},
      received(data) {
        this.updateList(camel(data.message))
      },
    },
  },
  setup(_, context) {
    const { root } = context
    const { $store } = root

    const { id, type } = context.root.$route.params

    const messagesRaw = ref([])
    const unreadMessagesIds = ref([])

    const sendLoading = ref(false)

    const userId = computed(() => $store.getters['driver/driverId'])

    const { makeRequest, loading } = useRequest({
      request: () => $store.dispatch('driver/getMessages', { orderId: id }),
      context,
    })

    const sentMassegeRequest = useRequest({
      successMessage: 'Сообщение отправлено!',
      request: data => $store.dispatch('driver/postMessage', data),
      context,
    })

    const fetchMessages = async () => {
      const { messages, unreadIds } = await makeRequest()
      messagesRaw.value = messages.map(message => ({
        ...message,
        isRead: !unreadIds.includes(message.id),
      }))
      unreadMessagesIds.value = unreadIds
    }

    const sendMessage = async (messData) => {
      const data = {
        messagebleType: capitalizedWord(type),
        messagebleId: id,
        ...messData,
      }
      await sentMassegeRequest.makeRequest(data)
      await fetchMessages()
    }

    const updateList = (data) => {
      const existingMessage = messagesRaw.value.find(item => item.id === data.id)
      if (existingMessage) {
        assign(existingMessage, data)
      } else {
        messagesRaw.value.push(data)
      }
      sendLoading.value = false
    }

    const { messages } = useMessages(messagesRaw, userId, unreadMessagesIds)

    watch(() => id, async () => {
      if (id) {
        await fetchMessages()
      } else {
        messagesRaw.value = []
      }
    }, { immediate: true, deep: true })

    watch(() => id, () => {
      root.$cable.unsubscribe('ChatChannel')
      root.$cable.subscribe({
        channel: 'ChatChannel',
        messageble_id: id,
        messageble_type: capitalizedWord(type),
      })
    }, { immediate: true })

    return {
      id,
      type,
      loading,
      sendMessage,
      messages,
      updateList,
      sendLoading,
      unreadMessagesIds,
    }
  },
}
